function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "ctyled");

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 7,
  y: 7,
  width: 490.67,
  height: 495.47,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 14
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 114.07,
  y: 115.12,
  width: 276.53,
  height: 279.24,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 14
});

var _ref5 =
/*#__PURE__*/
React.createElement("line", {
  x1: 252.33,
  y1: 44.49,
  x2: 252.33,
  y2: 218.48,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 14
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#000",
  points: "195.07 172.09 205.33 162.54 252.32 213.11 299.32 162.54 309.58 172.09 252.32 233.66 195.07 172.09"
});

var SvgCtyled = function SvgCtyled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "f156c57a-f6ff-455c-8055-f72cb3e73504",
    "data-name": "Layer 1",
    viewBox: "0 0 504.67 509.47",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCtyled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ctyled.9eb654f1.svg";
export { ForwardRef as ReactComponent };